export default __webpack_public_path__ + "static/kara-a5f4f963b55c96e572f97f5011596a90.png";